import { createSignal, onCleanup, Show } from 'solid-js';
import { Spinner, Card } from 'solid-bootstrap';
import { Service } from '../../service/download/download';

export const DownloadImageCard = () => {
    const [version, setVersion] = createSignal({});
    function isReady() {
        return version().download_url && version().download_url.length > 0;
    }
    const interval = setInterval(async () => {
        const versions = await Service.listVersions();
        if (versions.length > 0) {
            const download = await Service.downloadVersion(versions[0].uuid);
            if (download.download_url && download.download_url.length > 0) {
                setVersion(download);
                clearInterval(interval);
            }
        }
    }, 100);
    onCleanup(() => clearInterval(interval));
    return <Card>
        <Card.Body>
            <Card.Title>Download Timechief SD card image</Card.Title>
            <Card.Text>
                <Show when={isReady()}>
                    <a href={version().download_url} download={version().filename}>Download {version().filename}</a>
                </Show>
                <Show when={!isReady()}>
                    <Spinner animation="border" />
                </Show>
            </Card.Text>
        </Card.Body>
    </Card>
};